import React, { useEffect, useState } from "react";
import '../../App.css';
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import SearchIcon from '@mui/icons-material/Search';

import '../../../node_modules/firebase/compat/firestore';
import FormDialog from "./responseForm";
import { Chip } from "@mui/material";

const columns = [
  { id: 'ticketactions', label: 'Response', minWidth: 150},
  { id: 'dt', label: 'Date', minWidth: 150 },
  { id: 'tid', label: 'Ticket ID', minWidth: 150 },
  { id: 'fname', label: 'First Name', minWidth: 150 },
  { id: 'lname', label: 'Last Name', minWidth: 150 },
  { id: 'email', label: 'Email', minWidth: 150 },
  { id: 'stat', label: 'Status', minWidth: 150 },
  { id: 'helptopic', label: 'Help Topic', minWidth: 150 },
  { id: 'helpdetailsSpliced', label: 'Help Details', minWidth: 150},
];

const FilterStatusList = [
  {
    value: 'All',
    label: 'All',
  },
  {
    value: 'Open',
    label: 'Open',
  },
  {
    value: 'Resolved',
    label: 'Resolved',
  }
];

function createData(entry) {
  var dt = entry.datetime.toDate().toString().slice(0,24)
  var tid = entry.id
  var fname = entry.firstname
  var lname = entry.lastname
  var email = entry.email
  var stat = entry.status
  var helptopic = entry.helptopic
  var helpdetailsSpliced = entry.helpdetails.length > 15 ? entry.helpdetails.slice(0,15)+"..." : entry.helpdetails
  var helpdetails = entry.helpdetails
  var responsetime = entry.responsetime
  return { dt, tid, fname, lname, email, stat, helptopic,helpdetailsSpliced, helpdetails, responsetime};
}

var rows = []
var initialRows = []
var filteredRows = []
var searchKey = ""

function extractData(allDocs){

  rows = []
  for (let i=0; i < allDocs.length; i++){
    rows.push(createData(allDocs[i]));
  }  // need to `createdata` on every entry in allDocs and insert in array ` const rows`
  rows = [...rows].sort((a, b) => new Date(a.dt) - new Date(b.dt))
  for (let i=0; i < rows.length; i++){
    if (rows[i].stat === "Open"){
      initialRows.push(rows[i]);
    }
  }
}

var SortStates = {
  "Date" : false,
  "First Name" : true,
  "Last Name" : true,
  "Email" : true
}

export default function TicketList(props) {
  
  extractData(props.data) // by here need to have ROWS

  const [dataRows, setdataRows] = useState(initialRows)
  const [anchorEl, setAnchorEl] = useState(null)

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const SortCol = (columnName, order) => {
    var sortedRows = [];
    if (columnName === 'Date') {
      if (order === "asc")
        sortedRows = [...dataRows].sort((a, b) => new Date(a.dt) - new Date(b.dt))
      else 
        sortedRows = [...dataRows].sort((a, b) => new Date(b.dt) - new Date(a.dt))
    }
    else if (columnName === 'First Name') {
      sortedRows = [...dataRows].sort(function(a, b){
        let x = a.fname.toLowerCase();
        let y = b.fname.toLowerCase();
        if (order === "asc")
          return x.localeCompare(y);
        else 
          return y.localeCompare(x);
      })
    }
    else if (columnName === 'Last Name') {
      sortedRows = [...dataRows].sort(function(a, b){
        let x = a.lname.toLowerCase();
        let y = b.lname.toLowerCase();
        if (order === "asc")
          return x.localeCompare(y);
        else 
          return y.localeCompare(x);
      })
    }
    else if (columnName === 'Email') {
      sortedRows = [...dataRows].sort(function(a, b){
        let x = a.email.toLowerCase();
        let y = b.email.toLowerCase();
        if (order === "asc")
          return x.localeCompare(y);
        else 
          return y.localeCompare(x);
      })
    }
    else if (columnName === 'Help Topic') {
      sortedRows = [...dataRows].sort(function(a, b){
        let x = a.helptopic.toLowerCase();
        let y = b.helptopic.toLowerCase();
        if (order === "asc")
          return x.localeCompare(y);
        else 
          return y.localeCompare(x);
      })
    }
    SortStates[columnName] = !SortStates[columnName];
    setdataRows(sortedRows);
  }

  const FilterStatusCol = (filterStatus) => {
    filteredRows = []
    if (filterStatus === "All"){
      filteredRows = rows
    }
    else {
      for (let i=0; i < rows.length; i++){
        if (rows[i].stat === filterStatus){
          filteredRows.push(rows[i]);
        }
      }
    }
    SearchbyKeyword(searchKey)
  }

  const SearchbyKeyword = (keyword) => {
    setdataRows([])
    if (filteredRows.length == 0) {
      filteredRows = rows
    }
    for (let i=0; i < filteredRows.length; i++){
      let docData_stringValues = Object.values(filteredRows[i]).map(element => element.toString())
      docData_stringValues = [...docData_stringValues, filteredRows[i].dt].map(item => item.toLowerCase())
      for (let j = 0; j < docData_stringValues.length; j++) {
        const value = docData_stringValues[j];
        if (value.includes(keyword)){
          setdataRows((prev)=>{
            return[...prev,filteredRows[i]];
          });
          break
        }
      }
    }
  }
  

  const handleFilterMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleFilterMenuClose = () => {
    setAnchorEl(null);
  };


  return (
    <div>
      <Grid container spacing={1} style={{ maxWidth: 450, padding: "10px 5px"}}>
        <Grid item>
          <TextField label="Search by Keyword" variant="outlined" style ={{minWidth: 410}} size="small"
            InputProps={{
              endAdornment: (
                <InputAdornment>
                    <SearchIcon />
                </InputAdornment>
              )
            }}
            onChange={(event) => {
              event.preventDefault()
              searchKey = event.target.value.trim().toLowerCase()
              SearchbyKeyword(searchKey);
            }}
            >
          </TextField> 
        </Grid>
      </Grid>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer sx={{ maxHeight: 1000 }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    style={{ minWidth: column.minWidth }}
                  >
                    <b>{column.label}</b> {column.label === "Date" || column.label === "First Name" || column.label === "Last Name" || column.label === "Email" || column.label === "Help Topic"? 
                    <span>
                      {SortStates[column.label] ? 
                      <IconButton
                        hidden = {!SortStates[column.label]}
                        onClick={(event) => {
                          event.preventDefault()
                          SortCol(column.label, "asc");
                        }}>
                        <ArrowDropUpIcon/>
                      </IconButton>
                      :
                      <IconButton
                        hidden = {SortStates[column.label]}
                        onClick={(event) => {
                          event.preventDefault()
                          SortCol(column.label, "desc");
                        }}>
                        <ArrowDropDownIcon/>
                      </IconButton>}
                    </span>
                    :column.label === "Status"?
                    <span>
                      <IconButton onClick={handleFilterMenuOpen}>
                        <ArrowDropDownIcon/>
                      </IconButton>
                      <Menu
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleFilterMenuClose}
                      >
                        {FilterStatusList.map((option) => (
                          <MenuItem key={option.value} value={option.value}
                          onClick={(event) => {
                            event.preventDefault()
                            FilterStatusCol(option.label);
                            handleFilterMenuClose();
                          }}>
                          {option.label}
                          </MenuItem>
                        ))}
                      </Menu>
                    </span>
                    :""}
                  </TableCell>
                ))
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {dataRows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  return (
                    <TableRow>
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell key={column.id}>
                            {/* RENDER OTHER COLUMNS */}
                            {column.id === 'stat' 
                              ? '' : column.id !== 'ticketactions' 
                              ? value : row.stat === 'Open'
                              ? <FormDialog data={row}/> : row.responsetime}

                            {/* RENDER OPEN CHIP */}
                            {column.id === 'stat' && row.stat === 'Open' 
                              ? <Chip sx = {{bgcolor: "#6ea995", color: 'white'}} label="Open"/>:""}
                            
                            {/* RENDER RESOLVED CHIP */}
                            {column.id === 'stat' && row.stat === 'Resolved' 
                              ? <Chip color="default" variant="soft" label="Resolved"/>:""}
                          </TableCell> 
                        );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={dataRows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}